import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SearchForm from 'components/site/search_form'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  searchFormCondition: state.searchFormCondition,
  systemLabelMastersApi: state.systemLabelMastersApi,
})

const SearchContainer = connect(mapStateToProps, mapDispatchToProps)(SearchForm)

export default SearchContainer